import {
  Button,
  ButtonLink,
  LinkButton,
  LinkNav,
} from '@sleepstation/components'
import { HLayout, VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_SPACING, SIZE } from '@sleepstation/const'
import { stylesIfPropTrue } from '@sleepstation/style-api-helpers'
import { defaultAltTheme } from '@sleepstation/themes-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider, css } from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  as: `nav`,
  spacing: [1, 1, 1.25],
  align: LAYOUT_ALIGN.CENTER,
})``

const ArrowLink = styled(ButtonLink)``

const Primary = styled(HLayout).attrs({
  spacing: [0.75, 0.75, 0],
  align: LAYOUT_ALIGN.CENTER,
})`
  ${stylesIfPropTrue(
    `hidePreviousButton`,
    css`
      > *:first-child {
        visibility: hidden;
      }
    `
  )}

  ${stylesIfPropTrue(
    `hideNextButton`,
    css`
      > *:last-child {
        visibility: hidden;
      }
    `
  )}
`

const NextButton = styled(Button).attrs({
  size: SIZE.SMALL,
  kind: `secondary`,
  'data-cy': `onboarding-welcome-next-button`,
})`
  min-width: 290px;
`

const Secondary = styled(VLayout).attrs({
  align: LAYOUT_ALIGN.CENTER,
  spacing: LAYOUT_SPACING.LARGE,
})``

const CompleteButton = styled(LinkButton).attrs({
  size: SIZE.SMALL,
  'data-cy': `onboarding-welcome-complete-button`,
})`
  min-width: 290px;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const Nav = ({
  onPrevious,
  onNext,
  children,
  skipLink,
  nextButton,
  completeLink,
  hasNext,
  hasPrevious,
}) => (
  <Layout>
    <Primary hideNextButton={!hasNext} hidePreviousButton={!hasPrevious}>
      <ArrowLink
        size={SIZE.LARGE}
        icon="previous"
        onClick={onPrevious}
        kind="secondary"
      />
      {children}
      <ArrowLink
        size={SIZE.LARGE}
        icon="next"
        onClick={onNext}
        kind="secondary"
      />
    </Primary>
    <Secondary>
      {!hasNext && (
        <CompleteButton href={completeLink.url}>
          {completeLink.label}
        </CompleteButton>
      )}
      {hasNext && (
        <ThemeProvider theme={defaultAltTheme}>
          <NextButton onClick={onNext}>{nextButton.label}</NextButton>
        </ThemeProvider>
      )}
      {hasNext && skipLink && (
        <LinkNav
          data-cy={`onboarding-welcome-skip-link`}
          size={SIZE.X_SMALL}
          href={skipLink.url}
        >
          {skipLink.label}
        </LinkNav>
      )}
    </Secondary>
  </Layout>
)

Nav.propTypes = {
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  skipLink: PropTypes.object.isRequired,
  nextButton: PropTypes.object.isRequired,
  completeLink: PropTypes.object.isRequired,
  hasNext: PropTypes.bool.isRequired,
  hasPrevious: PropTypes.bool.isRequired,
}

export default Nav
